const styles = {
  container: {
    gap: 2,
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
  },
  btn: {
    alignSelf: 'center',
  },
};

export default styles;
